import './index.scss'
import Swiper from 'swiper/js/swiper.min.js'

$(document).ready(function(){
  let initindex = $('.section1 .tab-title a.active').index()

  var subswiper = new Swiper(".section1 .sub-title .mySwiper", {
    allowTouchMove: false,
    resizeObserver: true,
    autoHeight: true,
    effect : 'fade',
    fadeEffect: {
      crossFade: true,
    },
    on: {
      resize: function(){
        this.update(); //窗口变化时，更新Swiper的一些属性，如宽高等
      }, 
    },
  })

  subswiper.slideTo(initindex)

  $('.section1 .tab-title a').hover(function(){
    let index = $(this).index()
    subswiper.slideTo(index)
  })
  $('.section1 .bg-cont').mouseleave(function(){
    subswiper.slideTo(initindex)
  })

  if(window.location.href.indexOf('#md') != -1){
    let h = 0
    if($(window).width() > 992){
      h = $('.section1').offset().top
    }else{
      h = $('.mob-title').offset().top
    }
    $(document).scrollTop(h)
  }

  var $video = $('.section2 .left video')[0]
  $video.addEventListener('play', function () { //播放开始执行的函数
    $video.play();
    $('.section2 .left .video-play').fadeOut()
  });
  $video.addEventListener('pause', function () { //暂停开始执行的函数
    $video.pause();
    $('.section2 .left .video-play').fadeIn().css('display','flex')
  });

  $('.section2 .left .video-play').on('click',function(){
    $video.play();
  })

  // 移动端显示选择项
  $('.mob-search .show-select').on('click',function(){
    $('.section1').addClass('active')
    $('.job-mask').fadeIn(400)
  })
  $('.section1 .mob-btn >div').on('click',function(){
    $('.section1').removeClass('active')
    $('.job-mask').fadeOut(400)
  })
  $('.job-mask').on('click',function(){
    $('.section1').removeClass('active')
    $('.job-mask').fadeOut(400)
  })
})

